import { render, staticRenderFns } from "./BigTitle.vue?vue&type=template&id=3e7b349a&"
import script from "./BigTitle.vue?vue&type=script&lang=js&"
export * from "./BigTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports